import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { PageTitle } from '../../../../../../../_metronic/layout/core'
import { IExternalTransaction, ITransactionLog } from '../../core/response.types'
import { getExternalTransaction, getTransactionLogs } from '../../core/api'
import { EXTERNAL_TRANSACTION_DETAIL_BREADCRUMBS } from '../../core/consts'
import { DEFAULT_TRANSACTION_LOG_QUERY } from '../../core/query.defaults'
import { ExternalTransactionSummary } from './ExternalTransactionSummary'
import { ExternalTransactionLogsTable } from './ExternalTransactionLogsTable'

const AppSwal = withReactContent(Swal)

export const ExternalTransactionDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const [transaction, setTransaction] = useState<IExternalTransaction | null>(null)
  const [logs, setLogs] = useState<ITransactionLog[]>([])
  const [isLoadingTransaction, setIsLoadingTransaction] = useState(false)
  const [isLoadingLogs, setIsLoadingLogs] = useState(false)

  const transactionId = Number(id)

  useEffect(() => {
    if (!transactionId) return

    const loadTransaction = async () => {
      setIsLoadingTransaction(true)
      try {
        const { data } = await getExternalTransaction(transactionId)
        if (data.success) {
          setTransaction(data.data)
        }
      } catch (error) {
        console.error('Ошибка при загрузке транзакции:', error)
        AppSwal.fire({ icon: 'error', title: 'Ошибка', text: 'Не удалось загрузить транзакцию' })
      } finally {
        setIsLoadingTransaction(false)
      }
    }

    const loadLogs = async () => {
      setIsLoadingLogs(true)
      try {
        const { data } = await getTransactionLogs({
          ...DEFAULT_TRANSACTION_LOG_QUERY,
          external_transaction_id: transactionId,
        })
        if (data.success) {
          setLogs(data.data ?? [])
        }
      } catch (error) {
        console.error('Ошибка при загрузке логов:', error)
      } finally {
        setIsLoadingLogs(false)
      }
    }

    loadTransaction()
    loadLogs()
  }, [transactionId])

  return (
    <div>
      <div className='card sticky-top-tickets mb-7'>
        <PageTitle breadcrumbs={EXTERNAL_TRANSACTION_DETAIL_BREADCRUMBS} />
        <div className='card-header border-0 pt-5 pb-2'>
          <div className='d-flex align-items-center gap-4'>
            <button
              type='button'
              className='btn btn-sm btn-light'
              onClick={() => navigate('/logs/external-transactions')}
            >
              <i className='ki-duotone ki-arrow-left fs-4 me-1'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
              К списку
            </button>
            <h3 className='card-title align-items-start flex-column mb-0'>
              <span className='card-label fw-bold fs-3'>
                Транзакция #{transactionId}
              </span>
            </h3>
          </div>
        </div>
      </div>

      {isLoadingTransaction ? (
        <div className='card mb-7'>
          <div className='card-body text-center py-10'>Идёт загрузка...</div>
        </div>
      ) : transaction ? (
        <ExternalTransactionSummary transaction={transaction} />
      ) : (
        <div className='card mb-7'>
          <div className='card-body text-center py-10 text-muted'>Транзакция не найдена</div>
        </div>
      )}

      <div className='card mb-7'>
        <div className='card-header border-0 pt-5 pb-2'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-5 mb-1'>Логи</span>
          </h3>
        </div>
        <div className='card-body'>
          <ExternalTransactionLogsTable logs={logs} isLoading={isLoadingLogs} />
        </div>
      </div>
    </div>
  )
}
